import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-per-studenti',
  templateUrl: './per-studenti.component.html',
  styleUrls: ['./per-studenti.component.css']
})
export class PerStudentiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
